export default {
	setRoute(state, route) {
		state.route = route;
	},
};
